const chrs = [
  '▝',
  '▀',
  '▖',
  '▍',
  '▞',
  '▛',
  '▗',
  '▚',
  '▐',
  '▜',
  '▃',
  '▙',
  '▟',
  '▉'
];
const postprocessHelper = {
  name: 'helper',
  type: 'postProcessor',

  process(value, key, options, translator) {
    const lng = options.lng || translator.language;
    if (lng === 'en' && process.env.NEXT_PUBLIC_I18N_MANGLE) {
      return (value || key || '').replace(
        /\S/g,
        (c) => chrs[c.charCodeAt(0) % chrs.length]
      );
    } else {
      return value || key || '';
    }
  },

  overloadTranslationOptionHandler(args) {
    return {
      postProcess: 'helper'
    };
  }
};

export default postprocessHelper;
